import React, { useEffect, useState } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import { Multiselect } from '@cokitchen/cokitchen-components';
import { apiService } from 'utils/api';
import { BrandType } from 'models/brand.model';
import { ENUM_ITEM_TYPE } from 'utils/enum';
import { MultiselectItem } from '@cokitchen/cokitchen-components/dist/form/multiselect/types';

type Props = {
  className?: string;
  hasSearch?: boolean;
  disabled?: boolean;
  setBrands: (e: string[]) => void;
  returnAllBrands?: (arg0: BrandType[]) => void;
  defaultValue?: string[];
  label?: string;
};

const SelectBrand = ({
  className,
  setBrands,
  returnAllBrands,
  defaultValue = [''],
  label
}: Props) => {
  const { activeCokitchen } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const [brandsList, setBrandsList] = useState<MultiselectItem[]>([]);
  const [selectedBrands, setSelectedBrands] = useState<string[]>(defaultValue);

  useEffect(() => {
    fetchBrand();
    getBrandOptions();
  }, [activeCokitchen]);

  useEffect(() => {
    setSelectedBrands(defaultValue);
  }, [defaultValue]);

  const getBrandOptions = async () => {
    try {
      const res: any = await apiService.get('v2/brand_management/brands', {
        params: {
          cokitchen_id: activeCokitchen?.id,
          live: true,
          item_type: ENUM_ITEM_TYPE.FOOD
        },
        baseUrl: process.env.REACT_APP_BRAND_MGT_API_URL
      });
      setBrandsList(
        res?.data?.data?.map((brand: any) => ({
          value: brand.id,
          text: brand.name
        }))
      );
    } catch {
      console.log('error');
    }
  };
  const fetchBrand = async () => {
    try {
      setLoading(true);
      const params = {
        cokitchen_id: activeCokitchen.id
      };
      const res = await apiService.get('brand_management/brands', {
        params
      });
      const data: BrandType[] = res.data?.filter((b: BrandType) => b.item_type === 'FOOD');
      returnAllBrands?.(data);

      const brandArray = data.map((brand) => {
        return {
          value: brand.id,
          text: brand.name
        };
      });
      setBrandsList(brandArray);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={className}>
      <p>{label}</p>
      <Multiselect
        loading={loading}
        placeholder='Select one or more brands'
        options={brandsList}
        values={selectedBrands}
        onChange={(v) => {
          setSelectedBrands(v);
          setBrands(v);
        }}
      />
      <p>
        {brandsList.length === 0 ? (
          <p className='text-xs'>Brands loading ...</p>
        ) : selectedBrands.length === 0 ? (
          <p className='text-xs text-red-5'>No brand selected</p>
        ) : (
          <div />
        )}
      </p>
    </div>
  );
};

export default SelectBrand;
